// extracted by mini-css-extract-plugin
export default {"navbarCustom":"AppNavbar_navbarCustom__MktjG","logoText":"AppNavbar_logoText__SZvuK","disabledLink":"AppNavbar_disabledLink__8tJaZ"};